import { CartBackButton, CartCheckoutMobile, CartContent, CartTotal, DeadlineCounter, EmptyGroupOrderCart, FreeFreightProgress, } from 'cart';
import { CheckoutCouponCode, OrderTypeToggle } from 'checkout';
import ScrollToTop from 'components/UI/ScrollToTop';
import React from 'react';
import { useSelector } from 'react-redux';
import './CartPage.scss';
export default function CartPage() {
    const hasProductsInCart = useSelector((state) => state.cart.products.length > 0);
    const orderType = useSelector((state) => state.newCheckout.orderType);
    const isLoggedIn = useSelector((state) => state.user.isLoggedIn);
    return (React.createElement("div", { className: "cart-page" },
        React.createElement(ScrollToTop, null),
        React.createElement("div", { className: "cart-page__container" },
            React.createElement("h1", null, "Handlekurv"),
            React.createElement("div", { className: "cart-page__toggle-container" },
                React.createElement(OrderTypeToggle, { name: "cart" })),
            React.createElement(DeadlineCounter, null),
            !hasProductsInCart && orderType === 'group' ? (React.createElement(EmptyGroupOrderCart, null)) : (React.createElement(CartContent, null)),
            !hasProductsInCart && orderType !== 'group' && (React.createElement("div", { className: "cart-page__button-container" },
                React.createElement(CartBackButton, null))),
            hasProductsInCart && (React.createElement(React.Fragment, null,
                React.createElement(CartTotal, null),
                React.createElement(FreeFreightProgress, null),
                isLoggedIn && orderType !== 'group' ? (React.createElement("div", { className: "cart-page__coupon-container" },
                    React.createElement(CheckoutCouponCode, null))) : null))),
        React.createElement(CartCheckoutMobile, null)));
}
